import { Box, Divider, Grid, Paper, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FiAlertCircle, FiArrowDown, FiArrowRight, FiArrowUp } from "react-icons/fi";
import { formatTo2Decimals } from "../components/grid/columnDefinitions/columnDefinitions";

const MaterialDetailCard = ({ material }) => {
  const { t } = useTranslation();

  const getMCIColor = (mci) => {
    if (mci >= 0.8) return "#4CAF50";
    if (mci >= 0.5) return "#FFC107";
    return "#F44336";
  };

  const cardContent = useMemo(() => {
    if (!material) return [];
    return [
      // {
      //   icon: FiTag,
      //   title: "Basic Information",
      //   fields: [
      //     { label: "Category", value: material.category },
      //     { label: "Type", value: material.type || "Material" },
      //     { label: "Description", value: material.description },
      //     { label: "Unit", value: material.unit },
      //   ],
      // },
      // {
      //   icon: FiBarChart2,
      //   title: "Quantity & Environmental Impact",
      //   fields: [
      //     { label: "Quantity", value: formatTo2Decimals(material.quantity) + "kg" },
      //     { label: "Normalized Mass", value: formatTo2Decimals(material.normalizedMass) + "%" },
      //     { label: "Factor", value: formatTo2Decimals(material.factor) },
      //     { label: "GWP Total", value: formatTo2Decimals(material.gwp_total) + "kg CO₂e" },
      //     { label: "Normalized GWP", value: formatTo2Decimals(material.normalizedGwp) + "%" },
      //   ],
      // },
      // {
      //   icon: FiTarget,
      //   title: "Circularity Metrics",
      //   fields: [
      //     { label: "Material Circularity Indicator (MCI)", value: formatTo2Decimals(material.mci), color: getMCIColor(material.mci) },
      //     { label: "Linear Flow Index (LFI)", value: formatTo2Decimals(material.lfi) },
      //     {
      //       label: "Utility Factor",
      //       value: formatTo2Decimals(
      //         ((material.uf_functional_units || 1) * (material.uf_product_life || 0)) / ((material.uf_industry_avg_life || 1) * (material.uf_industry_avg_units || 1))
      //       ),
      //     },
      //     { label: "Product Life (Years)", value: formatTo2Decimals(material.uf_product_life) },
      //     { label: "Industry Average Life (Years)", value: formatTo2Decimals(material.uf_industry_avg_life) },
      //   ],
      // },
      {
        icon: FiAlertCircle,
        title: "Circularity Recommendation",
        fields:
          material.MCI >= 0.8
            ? [
                {
                  icon: FiArrowUp,
                  value: "This material demonstrates excellent circularity performance. Continue using this material in its current application.",
                  color: "#4caf50",
                },
              ]
            : material.MCI >= 0.5
            ? [
                {
                  icon: FiArrowRight,
                  value: "This material has moderate circularity. Consider increasing recycled content or exploring alternative materials with better circularity metrics.",
                  color: "#ffc107",
                },
              ]
            : [
                {
                  icon: FiArrowDown,
                  value: "This material has poor circularity. Evaluate alternatives with higher recycled content, longer lifespan, or better end-of-life recyclability.",
                  color: "#f44336",
                },
              ],
      },
    ];
  }, [material, formatTo2Decimals, getMCIColor]);
  return (
    <Paper sx={{ border: 1, borderColor: "#e0e0e0", borderRadius: 4, overflow: "hidden", padding: 1 }}>
      {/* <TableHeaderContainer>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center", padding: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <FiPackage size={24} color="seaGreen" />
          </Box>
          <Box>
            <Typography variant="Table Title">
              {t("Material Detail")}: {material?.description}
            </Typography>
          </Box>
        </Box>
      </Box> */}
      <Grid container sx={{ paddingX: 2 }} spacing={2}>
        {cardContent.map((c, i) => (
          <Grid
            key={i}
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            // sx={{ minWidth: 380 }}
          >
            <Box sx={{ display: "flex", gap: 1, alignItems: "center", paddingY: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <c.icon size={20} color="seaGreen" />
              </Box>
              <Box>
                <Typography sx={{ fontFamily: "Poppins", fontSize: 20, fontWeight: 500, color: "black" }}>{t(c.title)}</Typography>
              </Box>
            </Box>
            <Divider orientation="horizontal" />
            <Box sx={{ paddingY: 1 }}>
              {c.fields.map((f, ind) => (
                <Box
                  key={ind}
                  sx={{ display: "flex", gap: 2, justifyContent: "space-between", backgroundColor: ind % 2 == 1 ? "#f0f0f0" : "transparent", paddingY: 0.5, paddingX: 1 }}>
                  {f.label && (
                    <Box>
                      <Typography sx={{ fontFamily: "Poppins", fontSize: 16, fontWeight: 500, color: "#6b7280" }}>{t(f.label)} : </Typography>
                    </Box>
                  )}
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    {f.icon && (
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <f.icon size={20} color={f.color} />
                      </Box>
                    )}
                    <Box>
                      <Typography sx={{ fontFamily: "Poppins", fontSize: 16, color: f?.color || "black" }}>{t(f.value)}</Typography>
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ paddingY: 1 }} />
    </Paper>
  );
};

export default MaterialDetailCard;
